export default {
  globalCodesList:null,
  addGlobalCode:null,
  deleteGlobalCode:null,
  globalCodeDetails:null,
  updateGlobalCode:null,
  globalMeta:null,
}